import { useTranslation } from "react-i18next";
import { capitalizeTopicName } from "./electionColors";

export function useTopicLabel() {
  const { t } = useTranslation("elecciones");
  return (name: string | null | undefined) => {
    if (!name) return "";
    return t(`topics.${name}`, { defaultValue: capitalizeTopicName(name) });
  };
}
